import { api } from '@/services';

/** A empresa e o período da tela (SPEC-018, §3, item 8). */
export interface NotasAguardandoRecebimentoFiltro {
  cnpj_contribuinte: string;
  data_emissao_de: string;
  data_emissao_ate: string;
}

/** `UsaRecebimento` falso: o gestor não usa o Recebimento e o aviso não aparece. */
export interface NotasAguardandoRecebimento {
  UsaRecebimento: boolean;
  Quantidade: number;
}

export interface NotasAguardandoRecebimentoResponse {
  status: { resultado: boolean; mensagem: string };
  data: NotasAguardandoRecebimento | null;
}

export function fetchNotasAguardandoRecebimento(filtro: NotasAguardandoRecebimentoFiltro) {
  return api.post<NotasAguardandoRecebimentoResponse, NotasAguardandoRecebimentoFiltro>(
    'TurboPro/DocumentosFiscais/NotasAguardandoRecebimento',
    filtro
  );
}
